import React, { useMemo } from 'react';
import { Box, Flex, Text, Badge, Image, Link } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import logoImg from '../../../images/logo.png';

const NetworkProfilePreview = ({ draft, profile, allTags }) => {
  const selectedTags = useMemo(() => {
    const ids = draft?.tagIds || [];
    return (allTags || []).filter((t) => ids.includes(t.id)).slice(0, 3);
  }, [draft?.tagIds, allTags]);

  const imageUrl = profile?.profileImageUrl;
  const isPublic = !!draft?.isPublic;
  const name = draft?.fullName?.trim() || 'Il tuo nome';
  const bio =
    draft?.bio?.trim() ||
    'La biografia apparirà qui. Raccontati in poche righe nella sezione Identità.';

  return (
    <Box
      bg="linear-gradient(135deg, #2d3748 0%, #1a202c 100%)"
      borderRadius="xl"
      borderWidth="1px"
      borderColor="gray.600"
      p={{ base: 4, md: 5 }}
      mb={6}
    >
      <Flex
        justify="space-between"
        align="center"
        mb={3}
        gap={2}
        flexWrap="wrap"
      >
        <Text
          fontSize="xs"
          fontWeight="semibold"
          color="gray.400"
          textTransform="uppercase"
          letterSpacing="wider"
        >
          Anteprima Network
        </Text>
        <Badge
          colorScheme={isPublic ? 'green' : 'gray'}
          variant={isPublic ? 'solid' : 'outline'}
          fontSize="2xs"
        >
          {isPublic ? 'Visibile' : 'Non pubblico'}
        </Badge>
      </Flex>

      <Flex gap={4} align="flex-start">
        <Image
          src={imageUrl || logoImg}
          alt={name}
          boxSize={{ base: '72px', md: '80px' }}
          borderRadius="lg"
          objectFit={imageUrl ? 'cover' : 'contain'}
          bg="gray.700"
          border="2px solid"
          borderColor={isPublic ? 'yellow.400' : 'gray.600'}
          p={imageUrl ? 0 : 2}
          flexShrink={0}
        />
        <Box flex="1" minW={0}>
          <Text
            fontWeight="bold"
            fontSize={{ base: 'lg', md: 'xl' }}
            noOfLines={1}
          >
            {name}
          </Text>
          <Text fontSize="sm" color="gray.300" mt={1} noOfLines={3}>
            {bio}
          </Text>
          {selectedTags.length > 0 && (
            <Flex gap={1.5} mt={2} flexWrap="wrap">
              {selectedTags.map((tag) => (
                <Badge
                  key={tag.id}
                  size="sm"
                  bg="yellow.400"
                  color="black"
                  fontSize="2xs"
                  borderRadius="md"
                >
                  {tag.name}
                </Badge>
              ))}
            </Flex>
          )}
        </Box>
      </Flex>

      <Link
        as={RouterLink}
        to="/network"
        fontSize="sm"
        color="yellow.400"
        mt={3}
        display="inline-flex"
        alignItems="center"
        gap={1}
        _hover={{ textDecoration: 'underline' }}
      >
        Vedi la pagina Network pubblica
        <ExternalLinkIcon boxSize={3} />
      </Link>
    </Box>
  );
};

export default NetworkProfilePreview;
